import axiosClient from "./axiosClient";

class PortalApi {
  lookupByRegistrationCode = (registrationCode: string) => {
    const url = `/portal/lookup/${registrationCode}`;
    return axiosClient.get(url);
  };

  getDiaryHistories = (id: string) => {
    const url = `/portal/diary/${id}`;
    return axiosClient.get(url);
  };
}

const portalApi = new PortalApi();

export default portalApi;
